module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 groups.forEach ( function(grp) { 
__p+='\r\n';
 if(scope){
__p+=' '+
((__t=(scope))==null?'':__t)+
' ';
 } 
__p+='.';
 if(usecase){
__p+=''+
((__t=(usecase))==null?'':__t)+
'_';
 } 
__p+='phx-dynamicStyle-cell-'+
((__t=(type))==null?'':__t)+
'_'+
((__t=(UTILS.escapeJQueryString(grp.get("cod"))))==null?'':__t)+
' {\r\n';
 if(invert) { 
__p+='\r\ncolor :'+
((__t=(grp.get("bgcolor")))==null?'':__t)+
' !important;\r\nbackground : '+
((__t=(grp.get("color")))==null?'':__t)+
' !important;\r\nbox-sizing: border-box;\r\nborder: solid 2px '+
((__t=(grp.get("bgcolor")))==null?'':__t)+
';\r\n';
 } else { 
__p+='\r\ncolor : '+
((__t=(grp.get("color")))==null?'':__t)+
' !important;\r\nbackground : '+
((__t=(grp.get("bgcolor")))==null?'':__t)+
' !important;\r\n';
 } 
__p+='\r\nfont-weight: bold; text-align: center;\r\n}\r\n';
 }); 
__p+='';
}
return __p;
};
